import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import TreemapChart from "./TreemapChart";
import { formatPercent } from "@/utils/format";
import MediaArticleDrawer from "@/components/modals/MediaArticleDrawer";

interface CitationTableProps {
  brandId?: string;
  categoryId?: string;
  days?: number;
  modelId?: string;
  className?: string;
  style?: React.CSSProperties;
  // 可选：父组件直接传入数据时，内部不再发请求
  rows?: any[];
}

const CitationTable: React.FC<CitationTableProps> = ({
  brandId,
  categoryId,
  days,
  modelId,
  className,
  style,
  rows,
}) => {
  const { t } = useTranslation();
  const [mediaRows, setMediaRows] = useState<any[]>(rows || []);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDomainId, setSelectedDomainId] = useState<string | null>(null);
  const [selectedDomainName, setSelectedDomainName] = useState<string | null>(
    null
  );

  // 数据完全由父组件驱动；不再在挂载时自发请求
  useEffect(() => {
    setMediaRows(rows || []);
  }, [rows]);

  // 转换数据为树状图格式
  const convertToTreemapData = React.useMemo(() => {
    return mediaRows.map((row) => {
      // 从 ratio 字符串中提取数值（如 "34.65%" -> 34.65）
      const ratioValue = parseFloat(String(row.ratio).replace("%", ""));
      const value = isNaN(ratioValue) ? 0 : ratioValue;
      const item = {
        name: row.media,
        domain: row.domain,
        domainId: row.domainId,
        value: value,
        percentage: value, // 保持为数字类型，符合 TreemapDataItem 接口要求
      };
      return item;
    });
  }, [mediaRows]);

  // 处理树状图点击事件
  const handleTreemapClick = (item: any) => {
    // 设置选中的域名ID和域名名称并打开抽屉
    if (item.domainId) {
      setSelectedDomainId(item.domainId);
      setSelectedDomainName(item.name);
      setDrawerOpen(true);
    }
  };

  // 关闭抽屉
  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedDomainId(null);
    setSelectedDomainName(null);
  };

  return (
    <div className={className} style={style}>
      <div style={{ marginBottom: 12 }}>
        <span
          style={{
            whiteSpace: "nowrap",
            color: "rgb(148, 163, 184)",
            fontSize: 16,
          }}
        >
          {t("common.charts.citation_media_dist_title")}
        </span>
      </div>
      {/* 树状图视图 */}
      <div
        style={{ overflow: "hidden", backgroundColor: "#fff", height: "500px" }}
      >
        <TreemapChart
          data={convertToTreemapData}
          height={500}
          onItemClick={handleTreemapClick}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* 媒体文章抽屉 */}
      <MediaArticleDrawer
        open={drawerOpen}
        onClose={closeDrawer}
        title={`"${selectedDomainName}" 媒体引用文章`}
        domainId={selectedDomainId || undefined}
        brandId={brandId}
        categoryId={categoryId}
        modelId={modelId}
        days={days}
      />
    </div>
  );
};

export default CitationTable;
